import { render, staticRenderFns } from "./DialogSendMail.vue?vue&type=template&id=92007aea&scoped=true"
import script from "./DialogSendMail.vue?vue&type=script&lang=js"
export * from "./DialogSendMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92007aea",
  null
  
)

export default component.exports